"use client";

import Image from "next/image";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

interface NNLogoProps {
  /** Height & width in pixels */
  size?: number;
  className?: string;
}

export function NNLogo({ size = 24, className = "" }: NNLogoProps) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch by only rendering after mount
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Render a transparent placeholder of the same size to avoid layout shift
    return <span style={{ display: "inline-block", width: size, height: size }} />;
  }

  const src =
    resolvedTheme === "dark"
      ? "/Narrative Nexus Logo-o4.png"
      : "/Narrative Nexus Logo-o3.png";

  return (
    <Image
      src={src}
      alt="NarrativeNexus logo"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      priority
    />
  );
}
